module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[3]124.63880df.woff2";